/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input } from '@angular/core';
import { IcecontrolSettings } from '../../components/models/icesettings';

@Component({
  selector: 'iceqrbarcode',
  templateUrl: './iceqrbarcode.component.html',
  styleUrls: ['./iceqrbarcode.component.css']
})
export class IceqrbarcodeComponent implements OnInit {

  @Input() codeSettings: IcecontrolSettings = null;
  elementType : 'url' | 'canvas' | 'img' = 'url';
  value: string = "";
  
  constructor() { }

  ngOnInit() {
      '{trans_account:123456, firstname:Ravi, lastname: kumar}';
      this.value = this.codeSettings.properties["value"];
  }

}
